<div class="archive-confirmation-dialog">
  <p class="archive-confirmation-dialog__message">
    {{ 'settings.my_championed.archive_confirmation_message' | translateLang }}
  </p>

  <div class="archive-confirmation-dialog__actions">
    <button
      type="button"
      class="archive-confirmation-dialog__btn archive-confirmation-dialog__btn--cancel"
      (click)="onCancel()"
    >
      {{ 'settings.my_championed.cancel_button' | translateLang }}
    </button>
    <button
      type="button"
      class="archive-confirmation-dialog__btn archive-confirmation-dialog__btn--archive"
      (click)="onArchive()"
    >
      {{ 'settings.my_championed.archive_button' | translateLang }}
    </button>
  </div>
</div>
